import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon } from "@mui/material";
function WorkWaveLogoIconContrast(props) {
  const { width = "100%", sx = {}, ...rest } = props;
  return /* @__PURE__ */ jsx(
    SvgIcon,
    {
      "data-testid": "workWaveLogo",
      titleAccess: "WorkWave Logo",
      viewBox: "0 0 178.63 176.38",
      sx: { ...sx, height: "auto", width },
      ...rest,
      children: /* @__PURE__ */ jsxs("g", { id: "white_3_", children: [
        /* @__PURE__ */ jsxs("g", { id: "_Group_5_55_", children: [
          /* @__PURE__ */ jsx(
            "path",
            {
              d: "M89.17 1.75C41.5 1.83 2.91 40.55 2.99 88.22c.08 47.68 38.79 86.26 86.47 86.18 47.68-.08 86.26-38.79 86.18-86.47-.08-47.67-38.79-86.26-86.47-86.18zM11.88 80.27c.68-3.32 3.92-5.47 7.24-4.79 3.32.68 5.47 3.92 4.79 7.25h-.01a6.143 6.143 0 0 1-7.23 4.79c-3.32-.68-5.46-3.92-4.79-7.25zm4.59 20.44-.61-2.13a7.2 7.2 0 1 1 13.78-4.03l.61 2.13a7.2 7.2 0 1 1-13.78 4.03zm23.49 15.78-1.93 4.36c-1.69 3.6-5.97 5.16-9.57 3.47a7.21 7.21 0 0 1-3.59-9.31l2.27-5.05c1.61-3.62 5.85-5.26 9.47-3.66 3.66 1.61 4.96 6.56 3.35 10.19zm80.42 20.02s-2.1 4.69-7.21 4.44a7.08 7.08 0 0 1-6.49-4.44L90.12 86.36v-.06l-17.29 41.22a7.504 7.504 0 0 1-4.63 4.1c-3.96 1.22-8.16-1-9.38-4.96L48.65 95.81l-1.64 4.02c-.3.69-.7 1.32-1.19 1.89a7.21 7.21 0 0 1-8.4 1.89c-3.64-1.62-5.28-5.88-3.66-9.51l.27-.68 8.47-22.39c1.69-3.78 6.12-5.48 9.9-3.8 1.76.78 3.18 2.19 3.91 3.98l.1.28 3.82 11.2.73 2.1c.02.05.05.09.06.14l.06.18 5.85 17.02L84 61.32c1.69-3.78 6.12-5.48 9.9-3.8a7.75 7.75 0 0 1 4.24 5.07l3.96 12.17.31 1.04c.02.05.04.09.06.14l-.18-.59.07.16c.5 1.21 11.86 36.06 11.86 36.06l26.87-63.62s3.7-6.49 9.76-3.53c6.05 2.97 4.1 9.08 4.1 9.08l-34.57 83.01z",
              fill: "#fff"
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "_Path_9_00000106848203526231998620000009867347681862120873_",
              gradientUnits: "userSpaceOnUse",
              x1: 52.835,
              y1: -6268.166,
              x2: 43.731,
              y2: -6263.119,
              gradientTransform: "matrix(1 0 0 -1 0 -6165.81)",
              children: [
                /* @__PURE__ */ jsx("stop", { offset: 0, stopColor: "#4d4a4a", stopOpacity: 0 }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#221f1f" })
              ]
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              id: "_Path_9_56_",
              d: "M66.95 102.13 61.1 85.11l-.06-.18c-.65-1.72-2.4-3.56-4.81-2.86-1.94.57-2.97 2.45-3.44 3.51l-4.15 10.15 10.19 30.92a7.503 7.503 0 0 0 9.38 4.96 7.504 7.504 0 0 0 4.63-4.1l1.55-3.69-7.44-21.69z",
              opacity: 0.7,
              fill: "url(#_Path_9_00000106848203526231998620000009867347681862120873_)"
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "_Path_10_00000088134690320520095220000011443218238615802268_",
              gradientUnits: "userSpaceOnUse",
              x1: 91.485,
              y1: -6264.906,
              x2: 76.534,
              y2: -6256.613,
              gradientTransform: "matrix(1 0 0 -1 0 -6165.81)",
              children: [
                /* @__PURE__ */ jsx("stop", { offset: 0, stopColor: "#221f1f", stopOpacity: 0 }),
                /* @__PURE__ */ jsx("stop", { offset: 0.02, stopColor: "#221f1f", stopOpacity: 0.04 }),
                /* @__PURE__ */ jsx("stop", { offset: 0.19, stopColor: "#221f1f", stopOpacity: 0.31 }),
                /* @__PURE__ */ jsx("stop", { offset: 0.36, stopColor: "#221f1f", stopOpacity: 0.53 }),
                /* @__PURE__ */ jsx("stop", { offset: 0.53, stopColor: "#221f1f", stopOpacity: 0.71 }),
                /* @__PURE__ */ jsx("stop", { offset: 0.69, stopColor: "#221f1f", stopOpacity: 0.83 }),
                /* @__PURE__ */ jsx("stop", { offset: 0.85, stopColor: "#221f1f", stopOpacity: 0.9 }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#221f1f", stopOpacity: 0.93 })
              ]
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              id: "_Path_10_56_",
              d: "m114.24 111.54-1.97-6.03-9.73-29.55c-.59-1.82-2.35-3.72-4.84-3-1.94.57-2.97 2.45-3.44 3.51l-4.13 9.83v.05l16.55 50.16a7.075 7.075 0 0 0 6.49 4.44c5.11.25 7.21-4.44 7.21-4.44l1.15-2.74-7.29-22.23z",
              opacity: 0.7,
              fill: "url(#_Path_10_00000088134690320520095220000011443218238615802268_)"
            }
          )
        ] }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M161.79 50.81c0 1.14-.88 2.04-2.02 2.04-1.13 0-2.03-.9-2.03-2.04 0-1.12.9-2.01 2.03-2.01 1.14 0 2.02.89 2.02 2.01zm-3.72 0c0 1 .72 1.79 1.71 1.79.96 0 1.67-.79 1.67-1.78 0-1-.71-1.8-1.69-1.8-.97 0-1.69.8-1.69 1.79zm1.39 1.05H159v-2.01c.18-.04.43-.06.76-.06.37 0 .54.06.69.15.11.09.19.25.19.44 0 .22-.17.39-.41.47v.02c.19.07.3.22.36.49.06.31.1.43.14.5h-.49c-.06-.07-.1-.26-.16-.49-.04-.22-.16-.32-.41-.32h-.22v.81zm.01-1.14h.22c.25 0 .46-.09.46-.29 0-.18-.13-.31-.42-.31-.12 0-.2.01-.25.02v.58z",
            fill: "#002d5c"
          }
        )
      ] })
    }
  );
}
export {
  WorkWaveLogoIconContrast
};
//# sourceMappingURL=WorkWaveLogoIconContrast.js.map
